module.exports = __webpack_public_path__ + "img/levelling_solutions.90677270.jpg";